




















































































































































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { Button, Checkbox, FormItem, Input, Option, Select } from 'element-ui';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// Mixins
import places from '@/mixins/placeOptions';

// select
import CustomsLocation from '@/components/inputs/CustomsLocation.vue';

// sections
import CustomsImportSection from '@/components/documents/sections/CustomsInformationImport.vue';
import DeliverySection from '@/components/documents/sections/DeliveryInformation.vue';
import HeaderSection from '@/components/documents/sections/Header.vue';
import RequestSection from '@/components/documents/sections/RequestInformation.vue';
import TransportImportSection from '@/components/documents/sections/TransportInformationImport.vue';
import ImporterExporterSection from '@/components/documents/sections/ImporterExporterInformation.vue';

// Options
import { axleTypeOptions } from '@/constants/axleTypeOptions';
import { containerSizeOptions } from '@/constants/containerSizeOptions';
import { truckTypeOptions } from '@/constants/truckOptions';

// types
import {
  DelegatedStepsEnum,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  ShipmentDocumentFields_shipment,
  TaxTypeEnumBase,
  TransportationCargoTypeEnum,
  PriceCategorization
} from '@/types/graphql/schemaTypes';
@Component({
  components: {
    CustomsLocation,
    CustomsImportSection,
    DeliverySection,
    HeaderSection,
    ImporterExporterSection,
    NullableNumberInput,
    RequestSection,
    TransportImportSection,
    UtcDatePicker,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class CustomsClearanceImport extends Mixins(places) {
  @Prop() document!: ShipmentDocumentFields;
  @Prop({ default: false, type: Boolean }) isLoading!: boolean;

  formInput: ShipmentDocumentDataInput = {};

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;

  // select options
  readonly axleTypeOptions = axleTypeOptions();
  readonly containerSizeOptions = containerSizeOptions();
  readonly truckTypeOptions = truckTypeOptions();
  private readonly seaTransportation = [
    TransportationCargoTypeEnum.FCL,
    TransportationCargoTypeEnum.LCL
  ];

  created() {
    this.setFormInput();
    // disable auto select for place select
    this.autoSelect = false;
    // init transport type for place select
    this.transportationType = this.document.data.transportationType;
  }

  @Watch('document')
  setFormInput() {
    this.formInput = {
      // IMPORTANT re send readonly data
      transportCargoType: this.document.data?.transportCargoType,
      transportationType: this.document.data?.transportationType,
      shipmentCustomerRole: this.document.data?.shipmentCustomerRole,
      shipmentReference: this.document.data?.shipmentReference,
      // END IMPORTANT
      // Header information
      assignedOperator: this.document.data?.assignedOperator,
      issuanceDate: this.document.data?.issuanceDate,
      customerCompanyNumber: this.document.data?.customerCompanyNumber,
      customerShipperConsigneeStandardCode: this.document.data?.customerShipperConsigneeStandardCode,
      // Importer information
      customerName: this.document.data?.customerName,
      customerAddress: this.document.data?.customerAddress,
      // -----Freight information -----
      descriptionOfGoods: this.document.data?.descriptionOfGoods,
      quantityOfContainers: this.document.data?.quantityOfContainers,
      packagingQuantity: this.document.data?.packagingQuantity,
      packaging: this.document.data?.packaging,
      grossWeight: this.document.data?.grossWeight,
      grossVolume: this.document.data?.grossVolume,
      requiresWarehouseWork: this.document.data?.requiresWarehouseWork,
      customsLocation: this.document.data?.customsLocation,
      pickupDate: this.document.data?.pickupDate,
      // ----- TransportInformation section ----
      airCarrier: this.document.data?.airCarrier,
      consolidator: this.document.data?.consolidator,
      seaCarrier: this.document.data?.seaCarrier,
      masterBlNumber: this.document.data?.masterBlNumber,
      houseBlNumber: this.document.data?.houseBlNumber,
      portOfLoading: this.document.data?.portOfLoading,
      portOfDischarge: this.document.data?.portOfDischarge,
      vesselName: this.document.data?.vesselName,
      voyageNumber: this.document.data?.voyageNumber,
      flightNumber: this.document.data?.flightNumber,
      estimatedDateOfArrival: this.document.data?.estimatedDateOfArrival,
      // ----- DeliveryInformation section ----
      deliveryRemarks: this.document.data?.deliveryRemarks,
      freightDeliveryAddress: this.document.data?.freightDeliveryAddress,
      freightDeliveryContact: this.document.data?.freightDeliveryContact,
      // ----- CustomsInformation section -----
      customsClearanceDesiredDate: this.document.data?.customsClearanceDesiredDate,
      preliminaryFilings: this.document.data?.preliminaryFilings || false,
      otherLaws: this.document.data?.otherLaws || 'なし',
      dutyTaxPaymentMethod: this.document.data?.dutyTaxPaymentMethod,
      customerBankAccountNumber: this.document.data?.customerBankAccountNumber,
      customerPostponementNumber: this.document.data
        ?.customerPostponementNumber,
      freightRemarks: this.document.data?.freightRemarks,
      clientRemarks: this.document.data?.clientRemarks,
      shipmentInvoiceNumber: this.document.data?.shipmentInvoiceNumber,
      shipmentIncoterms: this.document.data?.shipmentIncoterms,
      priceCategorization: this.document.data?.priceCategorization || PriceCategorization.non_commercial,
      customerInsurance: this.document.data?.customerInsurance,
      customerInsuranceNumber: this.document.data?.customerInsuranceNumber,
      declaredValue: this.document.data?.declaredValue || 'なし',
      proofOfOrigin: this.document.data?.proofOfOrigin || false,
      // ----- RequestInformation section -----
      attachedDocuments: this.document.data?.attachedDocuments
        ? [...this.document.data?.attachedDocuments]
        : [],
      arrangementRemarks: this.document.data?.arrangementRemarks,
      delegatedSteps: this.document.data?.delegatedSteps
        ? [...this.document.data?.delegatedSteps]
        : [],
      shippingCompanyChargeAdvance: this.document.data
        ?.shippingCompanyChargeAdvance,
      dispatchArrangements: this.document.data?.dispatchArrangements
    };
  }
}
